@if (isLoading) {
    <div class="loading-container">
        <img class="loader-image" [src]="loadingImage" alt="Loading" />
        <span class="loading-message">loading</span>
    </div>
}

@if (!isLoading) {
    <ng-content></ng-content>
}
